import { createQueryParams } from '@nexio/emvio-util-app';
import config from '../../config/config';
import { buildTableSuccessActionBasedOnCount } from '../../utils/actionCreators';
import { navigateToMerchantDetails } from './utils/navigationUtils';

// Prevet Table Action Types
export const PREVET_LOAD = 'LEAD_TO_LIVE/PREVET_LOAD';
export const PREVET_SUCCESS = 'LEAD_TO_LIVE/PREVET_SUCCESS';
export const PREVET_FAILURE = 'LEAD_TO_LIVE/PREVET_FAILURE';
export const REFRESH_LEAD_TO_LIVE = 'LEAD_TO_LIVE/REFRESH';

export const fetchUrl = `${config.underwritingApiUrl}/prevet/list`;

export function refreshLeadToLive() {
    return {
        type: REFRESH_LEAD_TO_LIVE
    };
}

export function fetchPrevets(filters, page, pageSize, sorters) {
    const queryParamsString = createQueryParams({
        filters,
        page,
        pageSize,
        sorters
    });

    return {
        failureActionTypeOrCreator: getPrevetFailureActionCreator,
        fetchParams: {
            url: `${fetchUrl}${queryParamsString}`
        },
        loadActionTypeOrCreator: PREVET_LOAD,
        successActionTypeOrCreator: getPrevetSuccessActionCreator
    };
}

export function getPrevetSuccessActionCreator(results) {
    return buildTableSuccessActionBasedOnCount(results, PREVET_SUCCESS, 'prevets');
}

export function getPrevetFailureActionCreator(error) {
    return {
        error,
        type: PREVET_FAILURE
    };
}

export function selectPrevet(history, prevet, newTab) {
    navigateToMerchantDetails(history, prevet.onboardingId, newTab);
}
